export default function UniversityData() {
    return {
        id: 0,
        university: "",
        name: "",
        concentration: "",
        websiteURL: "",
        campus: "",
        country: "",
        studyLevel: "",
        duration: "",
        intakes: "",
        entryRequirements: "",
        ieltsScore: 0,
        toeflScore: 0,
        pteScore: 0,
        applicationDeadline: "",
        applicationFee: "",
        scholarshipAvailable: "",
        yearlyTuitionFees: "",
        remarks: "",
        backlogRange: "",
        eslelpDetail: "",
        applicationMode: "",
        gmatScore: 0,
        greScore: 0,
        detScore: 0,
        ieltsnoBandLessThan: 0,
        toeflnoBandLessThan: 0,
        ptenoBandLessThan: 0
    };
}
